<template>
    <div class="print-preview">
        <b-row>
            <b-col md="6" class="p-3">
                <rx-printed-form class="rx-form" :patient="patient" :user="user" :settings="settings"
                                 :prescriptions="prescriptions"></rx-printed-form>
            </b-col>
            <b-col md="6" class="ml-auto p-3">
                <rx-printed-form class="rx-form" :patient="patient" :user="user" :settings="settings"
                                 :prescriptions="prescriptions"></rx-printed-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import RxPrintedForm from './RxPrintedForm';

  export default {
    data() {
      return {
        settings: {
          clinic_name: 'Clinic Name',
          description: 'Internal Medicine - Kidney Disease',
          address: 'Rm 123 Hospital Cebu',
          operating_hours: 'Monday to Friday except Wednesday 3-6pm',
          contact: {
            phone: '3643423',
            email: 'email@gmail.com'
          }
        },
        patient: {},
        prescriptions: {}
      }
    },

    components: {RxPrintedForm},

    methods: {
      initialize() {
        this.patient = this.$route.params['patient'] || {};
        this.user = this.$route.params['user'] || {};
        this.prescriptions = this.$route.params['prescriptions'] || {};
      },

      print() {
        window.print();
      }
    },
    created() {
      this.initialize();
    }
  }
</script>

<style lang="scss">
    .print-preview {
        background: #FFFFFF;
        height: 100vh;
        margin: 0 10px;
        padding: 100px;
        font-size: 15px;
    }

    .print-preview p {
        margin-bottom: 2px;
    }

    .print-preview hr {
        background: #1d2124;
    }

    .print-preview table {
        border: 1px solid #000000;
    }

    .print-preview .table-bordered td, .print-preview .table-bordered th,
    .print-preview .table thead th {
        border: 1px solid #000000;
    }

    @media print {
        .print-preview {
            padding: 20px;
            font-size: 14px;
        }
        .btn {
            display: none;
        }
        .rx-form {
            width: 500px;
        }
        @page {
            size: landscape;
            margin: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Prescription/RxCertificate.vue